module.exports = __webpack_public_path__ + "img/4.929a8d12.jpg";